module.exports = __webpack_public_path__ + "static/media/grayscale.0a6da499.jpg";